import { render, staticRenderFns } from "./studyCardModal.vue?vue&type=template&id=0177ccb0&scoped=true&"
import script from "./studyCardModal.vue?vue&type=script&lang=js&"
export * from "./studyCardModal.vue?vue&type=script&lang=js&"
import style0 from "./studyCardModal.vue?vue&type=style&index=0&id=0177ccb0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0177ccb0",
  null
  
)

export default component.exports